import { useState, useEffect, createContext, useContext } from 'react';
import {
  getUserById,
  getCustomerById,
  fetchCustomerRoles
} from '../services/api';

export const AuthContext = createContext({
  user: null,
  customer: null,
  discount: 0,
  loading: false,
  setUser: () => { },
  refreshAuth: () => { }, // 👈 NUOVA funzione
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [discount, setDiscount] = useState(0);
  const [loading, setLoading] = useState(true);

  // 👇 Estrai la logica di caricamento in una funzione separata
  const loadAuthData = async (userId) => {
    try {
      const uRes = await getUserById(userId);
      setUser(uRes.data);
      localStorage.setItem('user', JSON.stringify(uRes.data));

      const c = await getCustomerById(uRes.data.customer_id);
      setCustomer(c.data);
      localStorage.setItem('customer', JSON.stringify(c.data));

      const rolesRes = await fetchCustomerRoles(c.data.customer_role_id);
      const d = Number(rolesRes.data.discount);
      setDiscount(d);
      localStorage.setItem('discount', String(d));
    } catch (e) {
      console.error('Errore AuthContext:', e);
    }
  };

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem('user'));
    const cachedCustomer = JSON.parse(localStorage.getItem('customer'));
    const cachedDiscount = localStorage.getItem('discount');

    const load = async () => {
      try {
        if (stored?.id) {
          // Se abbiamo tutto in cache, usa quello
          if (cachedCustomer && cachedDiscount) {
            setUser(stored);
            setCustomer(cachedCustomer);
            setDiscount(Number(cachedDiscount));
          } else {
            // Altrimenti carica da API
            await loadAuthData(stored.id);
          }
        }
      } catch (e) {
        console.error('Errore AuthContext:', e);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  // 👇 Funzione per ricaricare i dati dopo il login
  const refreshAuth = async (userId) => {
    setLoading(true);
    await loadAuthData(userId);
    setLoading(false);
  };

  return (
    <AuthContext.Provider value={{ 
      user, 
      customer, 
      discount, 
      setUser, 
      loading,
      refreshAuth // 👈 Esponi la funzione
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}